var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7115 14.5377C24.5502 13.9364 24.0773 13.4624 23.4777 13.3005C22.3821 13 17.9998 13 17.9998 13C17.9998 13 13.6177 13 12.5222 13.2891C11.934 13.4509 11.4496 13.9365 11.2883 14.5377C11 15.6359 11 17.9135 11 17.9135C11 17.9135 11 20.2026 11.2883 21.2893C11.4498 21.8905 11.9225 22.3645 12.5223 22.5264C13.6293 22.827 18 22.827 18 22.827C18 22.827 22.3821 22.827 23.4777 22.5379C24.0774 22.3761 24.5502 21.9021 24.7117 21.3009C24.9999 20.2026 24.9999 17.9251 24.9999 17.9251C24.9999 17.9251 25.0115 15.6359 24.7115 14.5377ZM16.6046 20.0176V15.8094L20.2487 17.9135L16.6046 20.0176Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.24b6939d4abf771d2fb46e524f87ce3a.svg";
export { ForwardRef as ReactComponent };